import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { RouteLoading } from "@/components/RouteLoading";

const ExercisesHubPage = lazy(() => import("@/components/exercises/ExercisesHubPage"));

interface ExercisesSearch {
  id?: string;
}

export const Route = createFileRoute("/_authenticated/exercises")({
  validateSearch: (search: Record<string, unknown>): ExercisesSearch => ({
    id: typeof search.id === "string" ? search.id : undefined,
  }),
  component: ExercisesRoute,
});

function ExercisesRoute() {
  return (
    <Suspense fallback={<RouteLoading label="Loading exercises..." />}>
      <ExercisesHubPage />
    </Suspense>
  );
}
